<template>
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.7414 14.599L15.6787 12.2536C14.5654 11.611 13.1787 12.4136 13.1787 13.6976V18.3896C13.1787 19.6736 14.5654 20.475 15.6787 19.831L19.7414 17.4856C20.8507 16.8456 20.8507 15.239 19.7414 14.599ZM15.1787 17.811L18.2414 16.043L15.1787 14.275V17.811Z"
      fill="#E60000"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.9507 11.0998C22.22 12.3598 23 14.1078 23 16.0438C23 17.9785 22.22 19.7278 20.9507 20.9865C20.5573 21.3745 20.5547 22.0078 20.944 22.4011C21.332 22.7931 21.9653 22.7958 22.3573 22.4065C23.9933 20.7865 25 18.5345 25 16.0438C25 13.5518 23.9933 11.3011 22.3573 9.6798C21.9653 9.2918 21.332 9.29447 20.944 9.68647C20.5547 10.0785 20.5573 10.7118 20.9507 11.0998Z"
      fill="#0D0D0D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.0507 20.9865C9.78 19.7278 9 17.9785 9 16.0438C9 14.1091 9.78 12.3598 11.0507 11.1011C11.4427 10.7118 11.4453 10.0785 11.0573 9.68647C10.668 9.29447 10.0347 9.2918 9.64267 9.6798C8.00667 11.3011 7 13.5518 7 16.0438C7 18.5358 8.00667 20.7865 9.64267 22.4078C10.0347 22.7958 10.668 22.7931 11.0573 22.4011C11.4453 22.0091 11.4427 21.3758 11.0507 20.9865Z"
      fill="#0D0D0D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.72 7.32352C26.952 9.55685 28.3333 12.6395 28.3333 16.0435C28.3333 19.4475 26.952 22.5302 24.72 24.7635C24.3293 25.1529 24.3293 25.7875 24.72 26.1769C25.1093 26.5675 25.744 26.5675 26.1333 26.1769C28.728 23.5835 30.3333 19.9995 30.3333 16.0435C30.3333 12.0875 28.728 8.50352 26.1333 5.91019C25.744 5.51952 25.1093 5.51952 24.72 5.91019C24.3293 6.29952 24.3293 6.93419 24.72 7.32352Z"
      fill="#0D0D0D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.28142 24.7635C5.04942 22.5302 3.66675 19.4462 3.66675 16.0435C3.66675 12.6395 5.04808 9.55685 7.28142 7.32352C7.67075 6.93419 7.67075 6.29952 7.28142 5.91019C6.89075 5.51952 6.25742 5.51952 5.86675 5.91019C3.27208 8.50485 1.66675 12.0875 1.66675 16.0435C1.66675 19.9982 3.27208 23.5822 5.86675 26.1769C6.25742 26.5675 6.89075 26.5675 7.28142 26.1782C7.67075 25.7875 7.67075 25.1542 7.28142 24.7635Z"
      fill="#0D0D0D"
    />
  </svg>
</template>
